export default "__VITE_ASSET__Cap5qE_3__"